import Api from '@/services/Api'

export default {
    getAllMonedas(){
        return Api().get('moneda/getAll')
    },
    getMonedaById(id){
        return Api().get('moneda/monedaById/'+id)
    },
    createMoneda(datos){
        return Api().post('moneda/create',datos)
    },
    updateMonedaById(datos){
        return Api().put('moneda/update',datos)
    },
    deleteMoneda(id){
        return Api().delete('moneda/delete/'+id)
    }
}